import { combineReducers } from 'redux';

import providers from './providers.reducer';

const reducer = combineReducers({
	providers
});

export default reducer;
